export enum FilterKeys {
  BookingType = "bookingType",
  CompositionId = "compositionId",
  /**
   * #534: the per-swap-combination row key (`SalesDto.compositionVariantKey`). The composition-overview table
   * filters on THIS key while "Kombinationen einzeln" is on, and on {@link FilterKeys.CompositionId} while it
   * is off — the two are mutually exclusive, and `EventAnalysisStoreService` clears both when the mode flips
   * (a filter on the key the other mode does not render would silently hide revenue with no visible checkbox).
   */
  CompositionVariantKey = "compositionVariantKey",
  LocationId = "locationId",
  EventId = "eventId",
  CompositionTypeId = "compositionTypeId"
}
